<app-header></app-header>
<div class="page-not-found">
  <div class="error-image">
    <img src="/assets/404_Spruce.png" alt="page-not-found-image">
  </div>
  <div class="error-message">
    <h1>Page Not Found</h1>
    <p>The page that you are looking for does not exist.</p>
    <p>Please return to home</p>
  </div>
  <div class="home-page-button">
    <button mat-flat-button [routerLink]="['/']">Return To Home</button>
  </div>
</div>
<app-footer></app-footer>
